import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './estimateInvoice.scss';
import cmLogo from 'assets/images/cmlogo.svg';
import moment from 'moment';
import CurrencyValue from 'ui-component/CurrencyValue';
import CurrencyValueFlex from 'ui-component/CurrencyValueFlex';
import { Skeleton } from '@mui/material';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { MdOutlineStickyNote2 } from 'react-icons/md';
import ProductCommentModal from './modals/ProductCommentModal';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { EditIcon, NoPhoneIcon } from 'ui-component/custom-icons/icons';
import { useSelector } from 'react-redux';
import StatusBadge from 'ui-component/StatusBadge';


// ✅ Clear
function EstimateDetailInvoice({ estimate, modulePath }) {
	const [settingsDetails, setSettingsDetails] = useState();
	const [productComment, setProductComment] = useState('');
	const [productName, setProductName] = useState('');
	const [productImage, setProductImage] = useState('');

	const history = useNavigate();
	const totalQty = estimate?.estimation_details?.reduce((total, detail) => total + (detail?.qty || 0), 0);
	const details = useSelector(state => state.settings?.invoiceSettingsDetails)

	const handleCommentModal = (product, image, comment) => {
		setProductComment(comment);
		setProductName(product);
		setProductImage(image);
	};
	const handleCloseComment = () => {
		setProductComment('');
		setProductName('');
		setProductImage('');
	};

	const statusAllowedToEdit = [
		'Estimated',
		'Pending Manager',
		'Paid',
		'Pending',
		// 'Accepted',
		'Draft',
		'Credit Note',
		'Open',
		'Unprocessed'
	];

	const getCookie = (name) => {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) return JSON.parse(decodeURIComponent(match[2]));
		return null;
	};
	const setCookie = (name, value, days = 7) => {
		const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/`;
	};
	useEffect(() => {
		const cookieSettings = getCookie('invoiceSettingsDetails');	
		if (cookieSettings) {
			setSettingsDetails(cookieSettings);
			return;
		}
		api.getSettings().then((res) => {
			setSettingsDetails(res?.data);
			setCookie('invoiceSettingsDetails', res?.data);
		});
	}, []);
	return (
		<>
			<div className="est-inv-container" style={{ padding: '15px', position: 'relative' }}>
				<div
					style={{
						position: 'absolute',
						right: '0',
						top: '0',
						zIndex: '10'
					}}
				>
					{statusAllowedToEdit.includes(estimate?.master_status?.name) && (
						<PermissionAllowed permissions={['Edit Estimation (Button)']}>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								disabled={!estimate?.id}
								onClick={() => {
									history(`${modulePath}/edit/${estimate?.id}`);
								}}
							>
								<EditIcon height="17px" width="17px" />
								Edit
							</button>
						</PermissionAllowed>
					)}
				</div>
				<div className="row m-0">
					{estimate ? (
						estimate?.transit_company?.name?.toLowerCase() == 'coolmix' ? (
							<>
								<div className="col-8 p-0">
									<div className="est-detail-logo" style={{ height: '36px' }}>
										<img src={cmLogo} height={'36px'} />
									</div>

									<div className="customer-details" style={{ marginTop: '20px' }}>
										<p className="m-0">
											<b>
												<PrivacyModeContent>{estimate?.customer?.name}</PrivacyModeContent>
											</b>{' '}
											<br />
											<PrivacyModeContent>{estimate?.customer?.address}</PrivacyModeContent> <br />
											<PrivacyModeContent>{estimate?.customer?.city + ', ' + estimate?.customer?.zipcode}</PrivacyModeContent> <br />
											<PrivacyModeContent>{estimate?.customer?.country}</PrivacyModeContent>
											{estimate?.customer?.shipping_address ? (
												<>
													<br />
													<br />
													<b>Ship To: </b>
													<br />
													<PrivacyModeContent>{estimate?.customer?.shipping_address}</PrivacyModeContent> <br />
													<PrivacyModeContent>
														{(estimate?.customer?.city == 'null' ? estimate?.customer?.city + ', ' : '') +
															estimate?.customer?.shipping_zipcode}
													</PrivacyModeContent>{' '}
													<br />
													<PrivacyModeContent>{estimate?.customer?.shipping_country}</PrivacyModeContent>
												</>
											) : (
												''
											)}
										</p>
									</div>
								</div>
								<div className="col-4 p-0">
								</div>
							</>
						) : (
							<>
								<div className="col-12">
									<div className="row orf-head">
										<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
											{settingsDetails?.logo_url ? (
												<div className="est-detail-logo" style={{ height: '36px' }}>
													<img src={settingsDetails?.logo_url} height={'36px'} />
												</div>
											) : (
												<div className="est-detail-logo" style={{ height: '36px' }}>
													<h3>{settingsDetails?.client_full_name}</h3>
												</div>
											)}
										</div>
										<div className="col-12 col-md-4 p-0">
											<div className="company-details">
												<div>
													{settingsDetails?.client_code && (
														<p className="m-0">
															<b> {settingsDetails?.client_full_name}</b> <br />
															{settingsDetails?.invoice_details1 && (
																<>{settingsDetails?.invoice_details1} <br /></>
															)}
															{settingsDetails?.invoice_details2 && (
																<>{settingsDetails?.invoice_details2} <br /></>
															)}
															{settingsDetails?.invoice_details3 && (
																<>{settingsDetails?.invoice_details3} <br /></>
															)}
															{settingsDetails?.invoice_details4 && (
																<>{settingsDetails?.invoice_details4} <br /></>
															)}
															{settingsDetails?.invoice_details5 && <>{settingsDetails?.invoice_details5}</>}
														</p>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-12 mobile-no-pad" style={{ marginTop: '20px' }}>
									<div className="row orf-head hide-on-mobile">
										<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
											<p className="m-0">
												<div style={{ width: '80px', marginBottom: '10px' }}>
													<StatusBadge itemStatus={'Customer'} />
												</div>
												<b>
													<PrivacyModeContent>{estimate?.customer?.name}</PrivacyModeContent>
												</b>{' '}
												<br />
												<PrivacyModeContent>{estimate?.customer?.address}</PrivacyModeContent> <br />
												<PrivacyModeContent>
													{(estimate?.customer?.city == 'null' ? estimate?.customer?.city + ', ' : '') + estimate?.customer?.zipcode}
												</PrivacyModeContent>{' '}
												<br />
												<PrivacyModeContent>{estimate?.customer?.country}</PrivacyModeContent>
											</p>
										</div>
										<div className="col-12 col-md-4 p-0">
											<div className="company-details">
												{estimate?.transit_company?.name && (
													<p className="m-0">
														<div style={{ width: '130px', marginBottom: '10px' }}>
															<StatusBadge itemStatus={'Transit Company'} />
														</div>
														<b>
															<PrivacyModeContent>{estimate?.transit_company?.name}</PrivacyModeContent>
														</b>{' '}
														<br />
														<PrivacyModeContent>{estimate?.transit_company?.address}</PrivacyModeContent> <br />
														<PrivacyModeContent>
															{(estimate?.transit_company?.city == 'null' ? estimate?.transit_company?.city + ', ' : '') +
																estimate?.transit_company?.zipcode}
														</PrivacyModeContent>{' '}
														<br />
														<PrivacyModeContent>{estimate?.transit_company?.country}</PrivacyModeContent>
													</p>
												)}
											</div>
										</div>
									</div>
									<div className="new-customer-detail-container show-on-mobile">
										<div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
											<div className="new-customer-detail-badge">Customer</div>
											<div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.4em' }}>
												<b>
													<PrivacyModeContent>{estimate?.customer?.name}</PrivacyModeContent>
												</b>{' '}
												<PrivacyModeContent>{estimate?.customer?.address}</PrivacyModeContent>
												<PrivacyModeContent>
													{(estimate?.customer?.city == 'null' ? estimate?.customer?.city + ', ' : '') + estimate?.customer?.zipcode}
												</PrivacyModeContent>{' '}
												<PrivacyModeContent>{estimate?.customer?.country}</PrivacyModeContent>
											</div>
										</div>
										{estimate?.transit_company?.name && (
											<div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
												<div className="new-customer-detail-badge">Transit Company</div>
												<div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.4em' }}>
													<b>
														<PrivacyModeContent>{estimate?.transit_company?.name}</PrivacyModeContent>
													</b>{' '}
													<PrivacyModeContent>{estimate?.transit_company?.address}</PrivacyModeContent>
													<PrivacyModeContent>
														{(estimate?.transit_company?.city == 'null' ? estimate?.transit_company?.city + ', ' : '') +
															estimate?.transit_company?.zipcode}
													</PrivacyModeContent>{' '}
													<PrivacyModeContent>{estimate?.transit_company?.country}</PrivacyModeContent>
												</div>
											</div>
										)}
									</div>
								</div>
							</>
						)
					) : (
						<>
							<div className="col-12">
								<div className="row orf-head">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										<div style={{ width: '200px' }}>
											<Skeleton variant="rounded" width={'100%'} height={40}></Skeleton>
										</div>
									</div>
									<div className="col-12 col-md-4 p-0">
										<div
											style={{
												position: 'absolute',
												right: '0',
												top: '0'
											}}
										>
											<div style={{ width: '100px', minWidth: 'unset', position: 'absolute', right: '-15px', top: '-20px' }}>
												<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
											</div>
										</div>
										<div className="company-details" style={{ marginTop: '10px' }}>
											<p className="m-0">
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '200px', marginBottom: '10px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12" style={{ marginTop: '35px' }}>
								<div className="row orf-head">
									<div className="col-12 col-md-8 p-0 d-flex align-items-center company-logo">
										<p className="m-0">
											<div style={{ width: '100px', marginBottom: '12px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
											</div>
											<b>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</b>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
											<div style={{ width: '150px', marginBottom: '5px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</p>
									</div>
									<div className="col-12 col-md-4 p-0">
										<div className="company-details">
											<p className="m-0">
												<div style={{ width: '100px', marginBottom: '12px' }}>
													<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
												</div>
												<b>
													<div style={{ width: '150px', marginBottom: '5px' }}>
														<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
													</div>
												</b>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
												<div style={{ width: '150px', marginBottom: '5px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</p>
										</div>
									</div>
								</div>
							</div>
						</>
					)}
				</div>

				<div className="row mx-0 hide-on-mobile" style={{ marginTop: '20px', alignItems: 'center' }}>
					<div className="col-6 col-md-8 p-0">
						{estimate ? (
							<h3 className="est-ref m-0">
								{estimate?.master_status?.status_type_id == 2 ? (
									estimate?.master_status?.name == 'Draft' ? (
										<span style={{ fontStyle: 'italic', color: '#929598', fontSize: '20px', fontWeight: '400' }}>
											Quotation {estimate?.estimation_number}
										</span>
									) : (
										`Quotation ${estimate?.estimation_number}`
									)
								) : (
									estimate?.is_draft == 1 ? (
										<span style={{ fontStyle: 'italic', color: '#929598', fontSize: '20px', fontWeight: '400' }}>
											{estimate?.is_credit_note ? 'Credit Note' : 'Invoice'} {estimate?.invoice_number}
										</span>
									) : (
										estimate?.master_status?.name == 'Draft' ? (
											<span style={{ fontStyle: 'italic', color: '#929598', fontSize: '20px', fontWeight: '400' }}>
												{estimate?.is_credit_note ? 'Credit Note' : 'Invoice'} {estimate?.invoice_number}
											</span>
										) : estimate?.is_credit_note ? (
											`Credit Note ${estimate?.invoice_number}`
										) : (
											`Invoice ${estimate?.invoice_number}`
										)
									)
								)}
							</h3>
						) : (
							<div style={{ width: '150px', marginBottom: '5px' }}>
								<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
							</div>
						)}
					</div>
					<div className="col-6 col-md-4 p-0">
						<table className="w-100">
							{estimate ? (
								estimate?.transaction_type == 'Invoice' ? (
									estimate?.master_status?.name == 'Credit Note' ? (
										<tr>
											<td>Date:</td>
											<td className="text-right">{moment(estimate?.start_date).format(CommonDateOnlyFormat)}</td>
										</tr>
									) : (
										<tr>
											<td>Date:</td>
											<td className="text-right">{moment(estimate?.invoice_date).format(CommonDateOnlyFormat)}</td>
										</tr>
									)
								) : (
									<>
										<tr>
											<td>Estimate Date:</td>
											<td className="text-right">{moment(estimate?.start_date).format(CommonDateOnlyFormat)}</td>
										</tr>
										<tr>
											<td>Due Date: </td>
											<td className="text-right">{moment(estimate?.expires_at).format(CommonDateOnlyFormat)}</td>
										</tr>
									</>
								)
							) : (
								<>
									<tr>
										<td>
											<div style={{ width: '110px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
										<td>
											<div style={{ width: '110px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div style={{ width: '110px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
										<td>
											<div style={{ width: '110px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
									</tr>
								</>
							)}
						</table>
					</div>
				</div>

				<div className="estimation-title show-on-mobile">
					{estimate ? (
						<h3 className="est-ref m-0">
							{estimate?.master_status?.status_type_id == 2 ? (
								estimate?.master_status?.name == 'Draft' ? (
									<span style={{ color: '#929598', fontSize: '20px', fontWeight: '400' }}>Quotation {estimate?.estimation_number}</span>
								) : (
									`Quotation ${estimate?.estimation_number}`
								)
							) : (
								estimate?.is_draft == 1 ? (
									<span style={{ color: '#929598', fontSize: '20px', fontWeight: '400' }}>
										{estimate?.is_credit_note ? 'Credit Note' : 'Invoice'} {estimate?.invoice_number}
									</span>
								) : (
									estimate?.master_status?.name == 'Draft' ? (
										<span style={{ color: '#929598', fontSize: '20px', fontWeight: '400' }}>
											{estimate?.is_credit_note ? 'Credit Note' : 'Invoice'} {estimate?.invoice_number}
										</span>
									) : estimate?.is_credit_note ? (
										`Credit Note ${estimate?.invoice_number}`
									) : (
										`Invoice ${estimate?.invoice_number}`
									)
								)
							)}
						</h3>
					) : (
						<div style={{ width: '150px', marginBottom: '5px' }}>
							<Skeleton variant="rounded" width={'100%'} height={25}></Skeleton>
						</div>
					)}
					{estimate ? (
						estimate?.transaction_type == 'Invoice' ? (
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>Date:</div>
								<div style={{ textAlign: 'right' }}>
									{estimate?.master_status?.name == 'Credit Note'
										? moment(estimate?.start_date).format(CommonDateOnlyFormat)
										: moment(estimate?.invoice_date).format(CommonDateOnlyFormat)}
								</div>
							</div>
						) : (
							<>
								<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
									<div>Estimate Date:</div>
									<div style={{ textAlign: 'right' }}>{moment(estimate?.start_date).format(CommonDateOnlyFormat)}</div>
								</div>
								<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
									<div>Due Date:</div>
									<div style={{ textAlign: 'right' }}>{moment(estimate?.expires_at).format(CommonDateOnlyFormat)}</div>
								</div>
							</>
						)
					) : (
						<>
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							</div>
							<div style={{ display: 'flex', justifyContent: 'center', gap: 5, width: '100%' }}>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
								<div>
									<div style={{ width: '110px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							</div>
						</>
					)}
				</div>

				<div className="est-inv-items hide-on-mobile" style={{ marginTop: '20px' }}>
					<table className="w-100">
						<thead>
							<tr>
								{!estimate ? (
									<div style={{ width: '30px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								) : (
									<th colSpan={2}>Model</th>
								)}
								<th className="hide-on-mobile text-center">
									{!estimate ? (
										<div style={{ width: '90px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										`Comment`
									)}
								</th>
								<th className="text-center">
									{!estimate ? (
										<div style={{ width: '50px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										`Quantity`
									)}
								</th>
								<th className="text-right">
									{!estimate ? (
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									) : (
										`Price`
									)}
								</th>
								<th className="text-right">
									{!estimate ? (
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									) : (
										`Total`
									)}
								</th>
							</tr>
						</thead>
						<tbody>
							{!estimate ? (
								[...Array(10)].map((e, i) => (
									<tr>
										<td className="hide-on-mobile">
											<div style={{ width: '23px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										</td>
										<td>
											<div style={{ width: '180px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
										<td className="text-center">
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</td>
										<td className="text-center">
											<div className="flex justify-content-center w-full">
												<div style={{ width: '50px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</div>
										</td>
										<td className="text-right d-none d-md-table-cell">
											<div className="flex justify-content-end w-full">
												<div style={{ width: '80px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</div>
										</td>
										<td className="text-right">
											<div className="flex justify-content-end w-full">
												<div style={{ width: '80px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
												</div>
											</div>
										</td>
									</tr>
								))
							) : (
								estimate?.estimation_details?.map((item) => (
									<tr>
										<td className="hide-on-mobile">
											{item?.product?.thumbnail_url ? (
												<img src={item?.product?.thumbnail_url} style={{ width: '23px', height: '35px' }} alt="product" />
											) : item?.product?.custom_thumbnail_url ? (
												<img src={item?.product?.custom_thumbnail_url} style={{ width: '23px', height: '35px' }} alt="product" />
											) : (
												<NoPhoneIcon width={'23px'} height={'32px'} />
											)}
										</td>
										<td style={{ maxWidth: '150px' }}>
											<p className="p-0 m-0">

												<a href={`/products/${item?.product?.id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
													{item?.product?.product_name} {item?.selectedColorName && ` ${item?.selectedColorName}`}
												</a>
												
											</p>
											{item?.comment ? <p className="hide-on-non-mobile mobile-prod-comment-ui">{item?.comment}</p> : ''}
										</td>
										<td style={{ maxWidth: '80px' }} className="hide-on-mobile text-center">
											<div
												style={{
													cursor: 'pointer'
												}}
												onClick={() => {
													handleCommentModal(item?.product?.product_name, item?.product?.thumbnail_url, item?.comment);
												}}
											>
												{item?.comment ? (
													<MdOutlineStickyNote2 size={18} />
												) : (
													'---'
												)}
											</div>
										</td>
										<td className="text-center">{item?.qty}</td>
										<td className="text-right d-none d-md-table-cell">
											<CurrencyValueFlex 
												currencyObject={item?.converted_currency_unit_price} 
												defaultCurrency={estimate?.currency} 
												flex={true}
											/>
										</td>
										<td className="text-right">
											<CurrencyValueFlex 
												currencyObject={item?.converted_currency_total_price} 
												defaultCurrency={estimate?.currency} 
												flex={true}
											/>
										</td>
									</tr>
								))
							)}
							<tr style={{ height: '10px' }}>
								<td></td>
							</tr>
							{estimate?.shipping_fees > 0 && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-center"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Shipping</td>
									<td className="text-right">
										<CurrencyValueFlex currencyObject={estimate?.converted_currency_total_shipping_fee} defaultCurrency={estimate?.currency} flex={true} />
									</td>
								</tr>
							)}

							{estimate?.total_discount > 0 && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Discount {estimate?.discount_type == 'percentage' ? `(${estimate?.discount}%)` : ''}</td>
									
									<td className="text-right">
										<CurrencyValueFlex currencyObject={estimate?.converted_total_discount} defaultCurrency={estimate?.currency} flex={true} />
									</td>
								</tr>
							)}

							{estimate?.vat_type == 'Excluding VAT' && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">VAT ({estimate?.vat_percent}%)</td>
									<td className="text-right font-weight-bold">
										<CurrencyValueFlex currencyObject={estimate?.converted_currency_vat_amount} defaultCurrency={estimate?.currency} flex={true} />
									</td>
								</tr>
							)}

							{estimate?.transit_fee && (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="d-md-none"></td>
									<td className="text-right">Transit Fee</td>
									<td className="text-right font-weight-bold">
										<CurrencyValueFlex currencyObject={estimate?.converted_currency_total_transit_fee} defaultCurrency={estimate?.currency} flex={true} />
									</td>
								</tr>
							)}

							{!estimate ? (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-right">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="hide-on-mobile text-center">
										<div className="w-full flex justify-content-center">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="d-md-none"></td>
									<td className="text-right">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
									<td className="text-right font-weight-bold">
										<div className="w-full flex justify-content-end">
											<div style={{ width: '60px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
											</div>
										</div>
									</td>
								</tr>
							) : (
								<tr>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile"></td>
									<td className="hide-on-mobile text-right">Total Qty</td>
									<td className="hide-on-mobile text-center">{totalQty}</td>
									<td className="d-md-none"></td>
									<td className="text-right">Total</td>
									<td className="text-right font-weight-bold">
										<CurrencyValueFlex currencyObject={estimate?.converted_currency_total} defaultCurrency={estimate?.currency} flex={true} />
									</td>
								</tr>
							)}
							{
								estimate?.is_credit_note === 0 ? (
									<>
										{
											estimate?.converted_currency_open_balance && (
												(estimate?.converted_currency_open_balance[estimate?.currency] > 0 || estimate?.converted_currency_open_balance[estimate?.currency] < 0) && (
													<tr>
														<td className="hide-on-mobile"></td>
														<td className="hide-on-mobile"></td>
														<td className="hide-on-mobile"></td>
														<td className="d-md-none"></td>
														{/* <td className="hide-on-mobile"></td> */}
														<td colSpan={2} className="text-right">Balance due</td>
														<td className="text-right font-weight-bold">
															<CurrencyValueFlex
																currencyObject={estimate?.converted_currency_open_balance}
																defaultCurrency={estimate?.currency}
																flex={true}
															/>
														</td>
													</tr>
												)
											)
										}
										{
											estimate?.is_credit_note === 1 && (
												<tr>
													<td className="hide-on-mobile"></td>
													<td className="hide-on-mobile"></td>
													<td className="hide-on-mobile"></td>
													<td className="hide-on-mobile"></td>
													<td className="d-md-none"></td>
													<td className="text-right" style={{ background: '#f1f1f1' }}>Balance</td>
													<td className="text-right font-weight-bold" style={{ background: '#f1f1f1' }}>
														<CurrencyValue
															currencyObject={estimate?.converted_currency_open_balance}
															defaultCurrency={estimate?.currency}
														/>
													</td>
												</tr>
											)
										}
									</>
								) : (
									estimate?.is_credit_note !== 1 && (
										<>
											{
												estimate?.converted_currency_open_balance && (
													(estimate?.converted_currency_open_balance[estimate?.currency] > 0 || estimate?.converted_currency_open_balance[estimate?.currency] < 0) && (
														<tr>
															<td className="hide-on-mobile"></td>
															<td className="hide-on-mobile"></td>
															<td className="hide-on-mobile"></td>
															<td className="hide-on-mobile"></td>
															<td className="d-md-none"></td>
															<td className="text-right">Balance due</td>
															<td className="text-right font-weight-bold">
																<CurrencyValueFlex
																	currencyObject={estimate?.converted_currency_open_balance}
																	defaultCurrency={estimate?.currency}
																	flex={true}
																/>
															</td>
														</tr>
													)
												)
											}
											{
												estimate?.is_credit_note === 1 && (
													<tr>
														<td className="hide-on-mobile"></td>
														<td className="hide-on-mobile"></td>
														<td className="hide-on-mobile"></td>
														<td className="hide-on-mobile"></td>
														<td className="d-md-none"></td>
														<td className="text-right" style={{ background: '#f1f1f1' }}>Balance</td>
														<td className="text-right font-weight-bold" style={{ background: '#f1f1f1' }}>
															<CurrencyValue
																currencyObject={estimate?.converted_currency_open_balance}
																defaultCurrency={estimate?.currency}
															/>
														</td>
													</tr>
												)
											}
										</>
									)
								)
							}
						</tbody>
					</table>
				</div>
				<div className="show-on-mobile" style={{ width: '100%', marginTop: '20px' }}>
					<div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
						{estimate?.estimation_details?.map((item) => (
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									width: '100%',
									borderBottom: '1px solid #eee',
									padding: '8px 0'
								}}
							>
								<div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginRight: 12 }}>
									<div className="" style={{ fontWeight: 500 }}>
										{item?.product?.product_name}
										{item?.selectedColorName && ` ${item?.selectedColorName}`}
									</div>

									<div style={{ display: 'flex', gap: 10, alignItems: 'center', color: '#737373' }}>
										<div style={{}}>QTY - {item?.qty}</div>
										<div>|</div>
										<div style={{ display: 'flex', gap: 4 }}>
											<span>
												Price -
											</span>
											<span>
											 	<CurrencyValueFlex currencyObject={item?.converted_currency_unit_price} defaultCurrency={estimate?.currency} flex={true} />
											</span>
										</div>
									</div>
									<div style={{ fontWeight: 500 }}>
										<CurrencyValue currencyObject={item?.converted_currency_total_price} defaultCurrency={estimate?.currency} />
									</div>
								</div>
								{estimate?.master_status?.name == 'Credit Note' ? (
									<div style={{ minWidth: 80 }}>{item?.credited_invoice?.invoice_number}</div>
								) : (
									<div style={{ width: '11%' }}>
										{item?.product?.thumbnail_url ? (
											<img src={item?.product?.thumbnail_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="product" />
										) : item?.product?.custom_thumbnail_url ? (
											<img
												src={item?.product?.custom_thumbnail_url}
												style={{ width: '100%', height: '100%', objectFit: 'cover' }}
												alt="product"
											/>
										) : (
											<NoPhoneIcon width={'41px'} height={'38px'} />	
										)}
									</div>
								)}
							</div>
						))}
						<div style={{display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: "center", paddingTop: 10}}>
							<div style={{fontWeight: 500}}>QTY {totalQty}</div>
							<div style={{fontWeight: 500, minWidth: '100px', display: 'flex', gap: '10px', justifyContent: 'end'}}>
								Total{' '}
								<CurrencyValueFlex currencyObject={estimate?.converted_currency_total} defaultCurrency={estimate?.currency} flex={true} />
							</div>
						</div>
					</div>
				</div>
			</div>

			{productComment && (
				<ProductCommentModal
					name={productName}
					image={productImage}
					comment={productComment}
					// show={commentModal}
					handleClose={() => handleCloseComment()}
				/>
			)}
		</>
	);
}

export default EstimateDetailInvoice;
